module.exports = __webpack_public_path__ + "img/word.21c1118e.png";